import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const mailerLite = defineConnector({
  identifier: "mailerLite",
  name: "MailerLite",
  tagLine: "Email marketing",
  logo,
  protocol: "http",
  tags: ["communication"],
  defaultUrlPattern: () => "https://connect\\.mailerlite\\.com/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Get an API key",
      items: [
        {
          kind: "markdown",
          content:
            "In your [MailerLite account](https://dashboard.mailerlite.com/integrations/api), navigate to **Integrations → API** and generate an API token.",
        },
      ],
    },
    {
      title: "Copy and paste the API key into the field below",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://connect.mailerlite.com/api/groups",
  },
});
